import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { IoCart } from "react-icons/io5";
import "./Header.css";
import { cartTotal } from "../../store/Services/Product";
import { useAtom } from "jotai";
import { cartLengthApiHit } from "../../JotaiStore";
import Logo from "../../images/finallogo.png";
import { CiUser } from "react-icons/ci";

const Header = () => {
  const { pathname } = useLocation();
  const [cartQty, setCartQty] = useState(0);
  const [apiHitAgain] = useAtom(cartLengthApiHit);

  const [menuOpen, setMenuOpen] = useState(false); // mobile menu

  useEffect(() => {
    if (!localStorage.getItem("accessToken")) {
      const currentData: any = localStorage.getItem("cartData");
      const count = JSON.parse(currentData);
      setCartQty(count?.length || 0);
    } else {
      cartTotal()
        .then((res: any) => setCartQty(res.count))
        .catch((err) => console.log("err", err));
    }
  }, [apiHitAgain]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const navigate = useNavigate();

  return (
    <div>
      <header>
        <div className="container">
          <div className="top-area flex space-bw al-center">
            {/* LOGO */}
            <div className="flex al-center wholesale-heading">
              <img src={Logo} alt="" onClick={() => navigate("/")} />
            </div>

            {/* DESKTOP NAV */}
            <div className="nav-pages desktop-only">
              <ul className="flex space-bw al-center">
                <li onClick={() => navigate("/")}>Home</li>
                <li onClick={() => navigate("/journal")}>Journal Books</li>
                <li onClick={() => navigate("/writing")}>Writing Journal</li>
              </ul>
            </div>

            {/* DESKTOP ACCOUNT + CART */}
            <div className="cart-header flex space-bw al-center desktop-only">
              <div className="icon-access" onClick={() => navigate("/account")}>
                <p className="flex al-center">
                  <CiUser size={22} />
                  &nbsp; Account Access
                </p>
              </div>

              <div
                className="flex space-bw al-center icon-2"
                onClick={() => navigate("/cart")}
              >
                <p>
                  <IoCart size={25} />
                </p>
                <p>{cartQty !== 0 ? `(${cartQty})` : ""}</p>
              </div>
            </div>

            {/* MOBILE CART + MENU ICON */}
            <div className="mobile-icons mobile-only flex al-center">
              <div
                className="icon-2 mobile-cart"
                onClick={() => navigate("/cart")}
              >
                <IoCart size={25} />
                <span>{cartQty !== 0 ? `(${cartQty})` : ""}</span>
              </div>

              <div className="toggle" onClick={() => setMenuOpen(!menuOpen)}>
                <i className="fa-solid fa-bars"></i>
              </div>
            </div>
          </div>

          {/* MOBILE MENU DROPDOWN */}
        </div>
      </header>
      {menuOpen && (
        <div className="mobile-menu mobile-only">
          <p onClick={() => navigate("/")}>Home</p>
          <p onClick={() => navigate("/journal")}>Journal Books</p>
          <p onClick={() => navigate("/writing")}>Writing Journal</p>
          <p onClick={() => navigate("/account")}>
            <button className="flex al-center account-mobile">
              <CiUser size={22} />
              &nbsp; Account Access
            </button>
          </p>
        </div>
      )}
    </div>
  );
};

export default Header;
